(() => {
  const PARAM_NAME = 'amb';
  const STORAGE_KEY = 'alimo_amb_code';
  const COOKIE_NAME = 'alimo_amb_code';
  const CART_ATTRIBUTE = '_alimo_amb_code';
  const SESSION_KEY = 'alimo_amb_cart_synced';
  const MAX_AGE_SECONDS = 90 * 24 * 60 * 60;

  function normalizeCode(value) {
    if (!value) return null;

    const code = String(value)
      .trim()
      .toUpperCase();

    if (!/^[A-Z0-9_-]{2,64}$/.test(code)) {
      return null;
    }

    return code;
  }

  function getIncomingCode() {
    try {
      const url = new URL(window.location.href);
      return normalizeCode(url.searchParams.get(PARAM_NAME));
    } catch {
      return null;
    }
  }

  function getStoredCode() {
    try {
      return normalizeCode(localStorage.getItem(STORAGE_KEY));
    } catch {
      return null;
    }
  }

  function saveCode(code) {
    try {
      localStorage.setItem(STORAGE_KEY, code);
    } catch {
      // localStorage indisponible : le cookie reste utilisé.
    }

    document.cookie =
      `${COOKIE_NAME}=${encodeURIComponent(code)}; ` +
      `path=/; max-age=${MAX_AGE_SECONDS}; SameSite=Lax`;
  }

  async function syncCartAttribute(code) {
    if (!code) return;

    const syncMarker = `${code}:${window.location.pathname}`;

    try {
      if (sessionStorage.getItem(SESSION_KEY) === syncMarker) {
        return;
      }
    } catch {
      // On continue même si sessionStorage est indisponible.
    }

    try {
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          attributes: {
            [CART_ATTRIBUTE]: code
          }
        })
      });

      if (!response.ok) {
        return;
      }

      try {
        sessionStorage.setItem(SESSION_KEY, syncMarker);
      } catch {
        // Sans conséquence sur le tracking.
      }
    } catch {
      // Une erreur réseau ne doit jamais bloquer la boutique.
    }
  }

  async function init() {
    const incomingCode = getIncomingCode();

    if (incomingCode) {
      saveCode(incomingCode);
      await syncCartAttribute(incomingCode);
      return;
    }

    const storedCode = getStoredCode();

    if (storedCode) {
      await syncCartAttribute(storedCode);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();